import './_grid.sass'

import Grid from './grid'

export default Grid('container')
